<template>
    <div :class="{ 'ah-authority-table': true, disabled: disabled }">
        <div class="auth-group" v-for="group in authDisplayList" :key="group.name">
            <div class="group-title">
                <div class="title">
                    <h3>{{ group.name }}</h3>
                </div>
                <div class="actions" v-if="!disabled">
                    <span class="txt-btn" @click="setAuthByGroup(true, group)" @keydown="() => {}">
                        全選
                    </span>
                    <span class="txt-btn" @click="setAuthByGroup(false, group)" @keydown="() => {}">
                        取消
                    </span>
                </div>
            </div>
            <table class="auth-item-table" cellspacing="0" cellpadding="0">
                <thead>
                    <tr>
                        <th class="cell-check">啟用</th>
                        <th class="cell-check" v-if="showPreset">身份預設</th>
                        <th class="cell-name">功能</th>
                        <th class="cell-info">說明</th>
                        <th class="cell-prefer-role" v-if="showPreferRole">建議角色</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in group.children" :key="item.unt" :class="{ checked: getAuth(item.unt) }">
                        <td class="cell-check">
                            <el-checkbox v-if="!disabled" :disabled="!item.isAvaliable" :value="getAuth(item.unt)" @change="checked => setAuth(checked, item.unt, item.isAvaliable)"></el-checkbox>
                            <span class="checkbox" v-if="disabled && getAuth(item.unt)"><span class="check"></span></span>
                        </td>
                        <td class="cell-check" v-if="showPreset">
                            <span class="checkbox" v-if="getPresetAuth(item.unt)"><span class="check"></span></span>
                        </td>
                        <td class="cell-name" @click="setAuth(!getAuth(item.unt), item.unt, item.isAvaliable)" @keydown="() => {}">
                            <span>{{ item.name }}</span>
                            <span class="unavailable" v-if="!item.isPayed">未購買</span>
                        </td>
                        <td class="cell-info">{{ item.info }}</td>
                        <td class="cell-prefer-role" v-if="showPreferRole">
                            {{ item.preferRole }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import { roleAuthorities } from '@/assets/commonData/roleAuthorities';

export default {
    name: 'ah-authority-table',
    props: {
        value: {
            type: [Array, String],
            default() {
                return [];
            },
        },
        presetUntList: {
            type: Array,
            default() {
                return [];
            },
        },
        ahooVer: {
            type: String,
            default() {
                return null;
            },
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        showOnlyEnabled: {
            type: Boolean,
            default: false,
        },
        showPreferRole: {
            type: Boolean,
            default: true,
        },
        showPreset: {
            type: Boolean,
            default: false,
        },
        disabledList: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        authList() {
            const LIST = _.cloneDeep(roleAuthorities);
            if (this.disabledList.length) {
                LIST.forEach((group) => {
                    const GROUP = group;
                    const FILTERED = _.filter(group.children, (o) => !this.disabledList.includes(o.unt));
                    GROUP.children = FILTERED;
                });
            }

            // SA 帳號：可看見全部（含未購買、Beta項目）
            if (this.isSAAdmin) return LIST;

            // 其他身份：只能看見有購買 且 非beta的功能
            const RETURN = [];
            LIST.forEach((group) => {
                const GROUP = { ...group, children: [] };
                group.children.forEach((item) => {
                    if (this.isPayed(item.unt) && !item.isBeta) {
                        GROUP.children.push(item);
                    }
                });
                if (GROUP.children.length !== 0) RETURN.push(GROUP);
            });

            return RETURN;
        },
        payedUntList() {
            return _.chain(this.$store.getters['menu/menuGroups'])
                .filter(['isPayed', true])
                .map('unt')
                .value();
        },
        isAccAdmin() {
            return this.$store.getters['account/isAccAdmin'];
        },
        isSAAdmin() {
            return this.$store.getters['account/isSAAdmin'];
        },
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        authDisplayList() {
            const list = [];
            this.authList.forEach((group) => {
                const newGroup = {
                    name: group.name,
                    children: [],
                };

                group.children.forEach((item) => {
                    const newItem = {
                        ...item,
                        isAvaliable: this.isAvaliable(item.unt),
                        isPayed: this.isPayed(item.unt),
                    };

                    if (this.showOnlyEnabled) {
                        if (this.getAuth(item.unt)) newGroup.children.push(newItem);
                    } else if (this.isAccAdmin || this.isSAAdmin) newGroup.children.push(newItem);
                    else if (newItem.isPayed) newGroup.children.push(newItem);
                });

                if (newGroup.children.length > 0) list.push(newGroup);
            });

            return list;
        },
    },
    methods: {
        getAuth(unt) {
            return this.value.includes(unt);
        },
        getPresetAuth(unt) {
            return this.presetUntList.includes(unt);
        },
        setAuth(enabled, unt, isItemAvaliable) {
            if (this.disabled) return;
            if (!isItemAvaliable) return;

            if (enabled) {
                // enabled = true : 加入
                const index = this.value.indexOf(unt);
                if (index === -1) {
                    this.value.push(unt);
                }
            } else {
                // enabled = false : 移除
                const index = this.value.indexOf(unt);
                if (index > -1) {
                    this.value.splice(index, 1);
                }
            }
        },
        setAuthByGroup(enabled, group) {
            if (this.disabled) return;

            for (let i = 0; i < group.children.length; i += 1) {
                const { unt, isAvaliable } = group.children[i];
                if (this.isAvaliable(unt)) {
                    this.setAuth(enabled, unt, isAvaliable);
                }
            }
        },
        isAvaliable(unt) {
            if (this.isAccAdmin || this.isSAAdmin) return this.isPayed(unt);
            return false;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.ah-authority-table {
    > .auth-group {
        margin: 0 0 40px 0;

        &:last-child {
            margin: 0 0 0 0;
        }

        > .group-title {
            display: table;
            width: 100%;
            line-height: 200%;
            margin-bottom: 5px;

            > .title {
                display: table-cell;
                vertical-align: top;
                padding: 0 0 0 15px;

                > h3 {
                    color: $main-color;
                    font-size: 11.5pt;
                }
            }

            > .actions {
                display: table-cell;
                vertical-align: top;
                text-align: right;

                .txt-btn {
                    padding: 0 5px;
                    color: #888;
                    font-size: 10pt;
                    cursor: pointer;
                    transition: 0.2s;

                    &:hover {
                        color: $main-color;
                    }
                }
            }
        }

        > .auth-item-table {
            width: 100%;
            border-top: 2px solid $main-color;
            font-size: 11pt;
            line-height: 180%;

            thead {
                th {
                    font-size: 9pt;
                    font-weight: normal;
                    text-align: left;
                    border-bottom: 1px solid #eee;
                    padding: 3px 20px;
                    color: #aaa;
                }

                .cell-info {
                    color: #aaa;
                    background-color: #fafafa;
                    padding: 0 0 0 20px;
                }

                .cell-prefer-role {
                    width: 250px;
                    color: #aaa;
                    background-color: #fafafa;
                    padding: 0 0 0 20px;
                }
            }

            td {
                border-bottom: 1px solid #eee;
            }

            .cell-check {
                position: relative;
                width: 50px;
                padding: 0 0 0;
                text-align: center;

                .checkbox {
                    position: relative;
                    display: inline-block;
                    top: 4px;
                    width: 16px;
                    height: 16px;
                    background-color: $main-color-fade;
                    border-radius: 4px;

                    .check {
                        position: absolute;
                        transform: rotate(-45deg);
                        top: 8px;
                        left: -3px;

                        &:before {
                            position: absolute;
                            top: 8px;
                            left: 4px;
                            content: "";
                            width: 9px;
                            height: 2px;
                            background-color: $main-color;
                        }

                        &:after {
                            position: absolute;
                            top: 4px;
                            left: 4px;
                            content: "";
                            width: 2px;
                            height: 5px;
                            background-color: $main-color;
                        }
                    }
                }
            }

            tbody {
                .cell-name {
                    color: #aaa;
                    width: 220px;
                    cursor: pointer;
                    padding: 3px 0 3px 20px;

                    &:hover {
                        color: $main-color;
                    }

                    > .unavailable {
                        background-color: #ccc;
                        color: #fff;
                        font-size: 9pt;
                        padding: 2px 4px;
                        font-weight: bold;
                        border-radius: 4px;
                        margin-left: 10px;
                    }
                }

                .cell-info {
                    color: #666;
                    background-color: #f7f7f7;
                    padding: 0 0 0 20px;
                }

                .cell-prefer-role {
                    width: 250px;
                    color: #666;
                    background-color: #f7f7f7;
                    padding: 0 0 0 20px;
                }

                tr.checked {
                    .cell-name {
                        color: #444;
                    }
                }

                tr:hover {
                    .cell-check,
                    .cell-name {
                        background-color: #eef0fa55;

                        &:hover {
                            color: $main-color;
                        }
                    }

                    .cell-info,
                    .cell-prefer-role {
                        background-color: #eef0faff;
                    }
                }
            }
        }
    }

    &.disabled {
        > .auth-group {
            > .auth-item-table {
                tbody {
                    .cell-name,
                    .cell-name.checked {
                        cursor: default !important;

                        &:hover {
                            color: #888 !important;
                        }
                    }
                }
            }
        }
    }
}
</style>
